module.exports = __webpack_public_path__ + "media/images/Matsuo-569424e9ac063e614faffb068114913d.jpg";